/**
 * Centralized API URL resolver.
 * Handles three runtime contexts:
 *  1. Electron / localhost  →  relative "/api"
 *  2. Mobile (Tailscale LAN) →  window.location.origin + "/api"
 *  3. Preview / cloud build →  REACT_APP_BACKEND_URL + "/api"
 *  4. Remote override       →  localStorage "remote_api_url" + "/api"
 */
function resolveAPI() {
  // Allow manual override via localStorage (for Electron → preview server)
  if (typeof window !== 'undefined') {
    const remoteUrl = localStorage.getItem('remote_api_url');
    if (remoteUrl) return `${remoteUrl.replace(/\/+$/, '')}/api`;
  }

  const envUrl = process.env.REACT_APP_BACKEND_URL || '';

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;

    // Electron or local dev-server: always use relative path
    if (host === 'localhost' || host === '127.0.0.1') {
      return '/api';
    }

    // Tailscale / LAN access: use current page origin
    if (!host.includes('preview.emergentagent.com')) {
      return `${window.location.origin}/api`;
    }
  }

  // Cloud preview
  return `${envUrl}/api`;
}

export const API = resolveAPI();

// Base URL without /api suffix — used for image paths, static assets, etc.
export const BACKEND_URL = API.replace(/\/api$/, '');
